import { j as o } from "../../_virtual/jsx-runtime.js";
import t from "styled-components";
import { useState as c, useEffect as w } from "react";
import b from "../asset/icon/show.svg.js";
import y from "../asset/icon/hide.svg.js";
function D(e) {
  const { variant: s = "default", onSendCode: d, onBeforeShowPassword: u, ...i } = e, [l, f] = c(!1), [r, p] = c(0), [n, x] = c(!1);
  w(() => {
    let a;
    return r > 0 ? a = setTimeout(() => p(r - 1), 1e3) : r === 0 && n && x(!1), () => clearTimeout(a);
  }, [r, n]);
  const g = async () => {
    !n && d && await d() && (p(60), x(!0));
  }, h = async () => {
    u ? await u() && f(!l) : f(!l);
  }, m = () => s === "password" ? l ? "text" : "password" : i.type || "text", v = () => s === "password" ? /* @__PURE__ */ o.jsx(P, { onClick: h, children: l ? /* @__PURE__ */ o.jsx(b, {}) : /* @__PURE__ */ o.jsx(y, {}) }) : s === "verification" ? /* @__PURE__ */ o.jsx(k, { onClick: g, className: n ? "counting" : "", children: n ? `${r}s` : "Send" }) : null;
  return /* @__PURE__ */ o.jsxs(j, { children: [
    e.label && /* @__PURE__ */ o.jsx(C, { style: e.labelStyle, children: e.label }),
    /* @__PURE__ */ o.jsxs(S, { children: [
      /* @__PURE__ */ o.jsx(
        I,
        {
          ...i,
          value: i.value === void 0 ? "" : i.value,
          type: m(),
          style: {
            ...e.style,
            paddingRight: s !== "default" ? "60px" : "20px"
          }
        }
      ),
      v()
    ] })
  ] });
}
const j = t.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`, S = t.div`
  position: relative;
  width: 100%;
`, I = t.input`
  width: 100%;
  height: 52px;
  flex-shrink: 0;
  border-radius: 12px;
  background: #f3f5f2;
  color: var(--color-text);
  font-family: 'Poppins';
  font-size: 16px;
  font-weight: 400;
  padding: 18px 20px;
  border: none;
  box-sizing: border-box;

  &::placeholder {
    color: var(--color-text-04);
  }

  &.error {
    border: 1px solid var(--color-error);
  }

  &:focus {
    outline: none;
    background: #f0f2ef;
  }
`, C = t.div`
  color: var(--color-text-07);
  font-family: 'Poppins';
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 10px;
`, P = t.div`
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 18px;
  color: var(--color-text-07);
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: var(--color-text);
  }
`, k = t.div`
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: var(--color-success-custom);
  font-family: 'Poppins';
  font-size: 16px;
  font-weight: 500;
  user-select: none;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover:not(.counting) {
    background: rgba(var(--btn-primary-rgb), 0.1);
  }

  &.counting {
    color: var(--color-text-07);
    cursor: not-allowed;
  }

  &:disabled {
    color: var(--color-text-07);
    cursor: not-allowed;
  }
`;
export {
  D as default
};
